import PropTypes from 'prop-types';

import { WorkspaceCreationProvider } from '../../context/WorkspaceCreationContext';
import useWorkspaceInvite from '../../context/WorkspaceInviteContext';

const SignedInUserLayout = ({ children }) => {
  // init
  const { isInviteUser } = useWorkspaceInvite();

  if (isInviteUser) return children;

  return (
    <WorkspaceCreationProvider>
      {children}
    </WorkspaceCreationProvider>
  );
};

const propTypes = {
  children: PropTypes.node.isRequired,
};

SignedInUserLayout.propTypes = propTypes;

export default SignedInUserLayout;
